import { dehydrate, QueryClient } from '@tanstack/react-query'
import priceService from './price.service'
import { EPriceQueryKey } from './price.types'
import type {
  UserGetPricePerformanceParams,
  UserGetProjectPriceChartParams,
  UserGetProjectPriceChartSnapshotParams,
} from '../api'

export const getMarketPricePerformanceOptions = () => {
  return {
    queryKey: [EPriceQueryKey.MARKET_PRICE_PERFORMANCE],
    queryFn: () => priceService.getMarketPricePerformance(),
    refetchInterval: 1000 * 60 * 1,
  }
}

export const prefetchMarketPricePerformance = async () => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(getMarketPricePerformanceOptions())
  return dehydrate(queryClient)
}

export const getPricePerformanceOptions = (
  params: UserGetPricePerformanceParams,
) => {
  return {
    queryKey: [EPriceQueryKey.PRICE_PERFORMANCE, params],
    queryFn: () => priceService.getPricePerformance(params),
  }
}

export const getProjectPriceChartOptions = (
  params: UserGetProjectPriceChartParams,
) => {
  return {
    queryKey: [EPriceQueryKey.PRICE_TS, params],
    queryFn: () => priceService.getProjectPriceChart(params),
    enabled: !!params.token && !!params.period,
  }
}

export const getProjectPriceChartSnapshotOptions = (
  params: UserGetProjectPriceChartSnapshotParams,
) => {
  return {
    queryKey: [EPriceQueryKey.PRICE_CHART_SNAPSHOT, params],
    queryFn: () => priceService.getProjectPriceChartSnapshot(params),
  }
}
